import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './ui/slab.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

// The inline boot door in index.html is replaced, not layered over — React
// owns the same node, so there is no flash between the static door and the
// interactive one.
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
